export default __webpack_public_path__ + "static/Homepage-Banner-Mobile-Week-2-6195eddd233cb6bc88d081dcd0168885.webp";